import { ListItemProps, SEVERITIES_COLORS } from '@silverfort/sf-components';
import { INCIDENT_SEVERITY, INCIDENT_STATUS, INCIDENT_TYPE } from '@silverfort-nodelibs/common/utils/consts';

const KIND_KEY = 'kind';
const SEVERITY_KEY = 'severity';
const STATUS_KEY = 'status';

const INCIDENT_AGGREGATION_OPTIONS: ListItemProps<string>[] = [
    {
        title: 'Incident Type',
        value: KIND_KEY
    },
    {
        title: 'Severity',
        value: SEVERITY_KEY
    },
    {
        title: 'Status',
        value: STATUS_KEY
    }
];

interface ParsedAggregationField {
    label: string;
    color?: string;
}

const AGGREGATION_FIELD_TO_PARSER: Record<string, (value: unknown) => ParsedAggregationField> = {
    [KIND_KEY]: (value: unknown) => {
        const enumValue = Object.values(INCIDENT_TYPE).find((type) => type.label === value);
        return {
            label: enumValue?.guiName || ''
        };
    },
    [STATUS_KEY]: (value: unknown) => {
        const enumValue = Object.values(INCIDENT_STATUS).find((status) => status.value === Number(value));
        return {
            label: enumValue?.label || '',
            color: enumValue?.graphColor || ''
        };
    },
    [SEVERITY_KEY]: (value: unknown) => {
        const enumValue = Object.values(INCIDENT_SEVERITY).find((severity) => severity.value === Number(value));
        return {
            label: enumValue?.label || '',
            color: enumValue ? SEVERITIES_COLORS[enumValue?.value]?.hex : undefined
        };
    }
};

const AGGREGATION_FIELD_TO_OPTIONS: Record<string, ListItemProps<string>[]> = {
    [KIND_KEY]: Object.values(INCIDENT_TYPE).map((type) => ({
        title: type.guiName,
        value: type.label
    })),
    [STATUS_KEY]: Object.values(INCIDENT_STATUS)
        .filter((status) => ![INCIDENT_STATUS.ONGOING.value, INCIDENT_STATUS.ACKNOWLEDGED.value].includes(status.value))
        .map((status) => ({
            title: status.label,
            value: status.value.toString()
        })),
    [SEVERITY_KEY]: Object.values(INCIDENT_SEVERITY).map((severity) => ({
        title: severity.label,
        value: severity.value.toString()
    }))
};

export { INCIDENT_AGGREGATION_OPTIONS, AGGREGATION_FIELD_TO_PARSER, AGGREGATION_FIELD_TO_OPTIONS };
